/**
 * Public types for @d-m-organization/pricing-ui.
 *
 * These mirror the Hub API response shapes with Stripe internals stripped.
 * Consumers should import types from the package root, not from this file.
 */
// ---------------------------------------------------------------------------
// Error
// ---------------------------------------------------------------------------
export class PricingError extends Error {
    status;
    code;
    constructor(status, code, message) {
        super(message);
        this.name = "PricingError";
        this.status = status;
        this.code = code;
        // Ensure instanceof works across transpilation targets
        Object.setPrototypeOf(this, PricingError.prototype);
    }
}
